'use strict';
var Passenger = /** @class */ (function () {
    function Passenger(type, primary) {
        if (primary === void 0) { primary = false; }
        this.type = type;
        this._primary = primary;
    }
    Object.defineProperty(Passenger.prototype, "name", {
        get: function () {
            return this.firstName && this.lastName ? (this.firstName + " " + this.lastName) : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Passenger.prototype, "formattedType", {
        get: function () {
            return this.type.toLocaleUpperCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Passenger.prototype, "formattedName", {
        get: function () {
            return this.name ? this.name : this.formattedType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Passenger.prototype, "isPrimary", {
        get: function () {
            return this._primary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Passenger.prototype, "primary", {
        set: function (val) {
            this._primary = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Passenger.prototype, "missingInfo", {
        get: function () {
            var result = [];
            if (this.missing_info)
                result.concat(this.missing_info);
            /*
            if (
                !this.emergencyContact ||
                (
                    !this.emergencyContact.no_contact &&
                    (!this.emergencyContact.name || !this.emergencyContact.country || !this.emergencyContact.phone_prefix || !this.emergencyContact.phone_number)
                )
            ) {
                result.push('emergencyContact');
            }
            */
            if (!this.personalDocuments ||
                !this.personalDocuments.type ||
                !this.personalDocuments.number ||
                (!this.personalDocuments.lifelong && !this.personalDocuments.expiration_date) ||
                !this.personalDocuments.issuing_country ||
                !this.personalDocuments.nationality ||
                !this.personalDocuments.date_of_birth) {
                result.push('personalDocuments');
            }
            /*if (!this.addressInUSA ||
                !this.addressInUSA.state ||
                (
                    this.addressInUSA.state !== 'outside_usa' &&
                    (!this.addressInUSA.address || !this.addressInUSA.zip_code || !this.addressInUSA.city)
                )
            ) {
                result.push('addressInUSA');
            }
    */
            if (!this.studentFare || !this.studentFare.document_number || !this.studentFare.fiscal_number || !this.studentFare.confirm) {
                result.push('studentFare');
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    return Passenger;
}());
export { Passenger };
